import request from "@/lib/request/request";
import {
  EnumAiRecommendStatus,
  EnumAuditStatus
} from "../exambuilder/candidate-v3/candidate-v3-enum";
import { EnumReadingGuidelinesType } from "../exambuilder/configGroup";
import { EnumQuestionType } from "../exambuilder/question-v2";
import Model from "../model";

export enum ResultStatus {
  UNKNOWN = 0, // 未知
  NORMAL = 1, // 正常/成功
  ERROR = 2, // 异常
  UNNECESSARY = 255 // 不需要
}

export enum LrResultStatus {
  UNKNOWN = 0, // 未知
  SUCESS = 1, // 成功
  ERROR = 2, // 失败（不可重试）
  FAILED = 3, // 失败（可重试）
  IGNORE = 255 // 忽略
}

export enum HandResultStatus {
  NOTREQUIREMENT = 0,
  SUCCESS = 1,
  ERROR = 2,
  NOSETTING = 255
}

export class Options extends Model {
  content = "";
  key = "";
  isRight = EnumBoolOption.FALSE;
}

export class ColorQuestionAnswer extends Model {
  colorQuestionId = 0;
  imgUrl = "";
  optionList: Options[] = [new Options()];
  isAnswered = EnumBoolOption.FALSE;
  isRight = false;
  key = "";

  // 前端
  get rightAnswerKey() {
    return this.optionList.find(item => item.isRight === 1)?.key || "";
  }
}

export class ColorDetectionConfig extends Model {
  blindnessResult: ResultStatus = ResultStatus.UNKNOWN; // 色盲结果 色盲结果 0:未知 1:正常 2:异常 255:不需要
  weaknessResult: ResultStatus = ResultStatus.UNKNOWN; // 色弱结果 0:未知 1:正常 2:异常 255:不需要
  answerNumber = 0; // 提交次数
  colorQuestionAnswerList: ColorQuestionAnswer[] = [new ColorQuestionAnswer()];
}

export class ResultStatusClass extends Model {
  message = "";
  scarResultStatus = 0;
}

export class FaceDetectionConfig extends Model {
  scar = new ResultStatusClass();
}

export class FaceShowDetectionConfig extends Model {
  successNumber = 0; // 成功样本数
  errorNumber = 0; // 异常样本数
  otherNumber = 0; // 模糊样本数
  successImgUrlList: string[] = [""]; // 成功样本
  errorImgUrlList: string[] = [""]; // 失败样本
}

// 电子签名
export class SignatureConfig extends Model {
  imgUrl = ""; // 图片链接
}

export class JumpOutDetectionConfig extends Model {
  errorNumber = 0; // 异常次数
  violationNumber = 0; // 次数限制
}

export class HandDetectionResultDetailItem {
  all = 0;
  l = 0;
  r = 0;
  l1 = 0;
  l2 = 0;
  l3 = 0;
  r1 = 0;
  r2 = 0;
  r3 = 0;
}

export class HandDetectionConfig extends Model {
  videoUrl = ""; // 最终视频链接
  videoId = "";
  imgUrlList: string[] = [""]; // 最终图片链接列表
  // resultFlexible: HandResultStatus = HandResultStatus.NOSETTING; // 灵活度结果 0:未按要求拍摄 1:成功无异常 2:失败有异常 255:未配置
  // resultFlexibleL: HandResultStatus = HandResultStatus.NOSETTING; // 灵活度结果左
  // resultFlexibleR: HandResultStatus = HandResultStatus.NOSETTING; // 灵活度结果右
  // resultComplete: HandResultStatus = HandResultStatus.NOSETTING; // 完整度结果
  // resultCompleteL: HandResultStatus = HandResultStatus.NOSETTING; // 完整度结果左
  // resultCompleteR: HandResultStatus = HandResultStatus.NOSETTING; // 完整度结果右
  // resultScar: HandResultStatus = HandResultStatus.NOSETTING; // 疤痕结果
  // resultScarL: HandResultStatus = HandResultStatus.NOSETTING; // 疤痕结果左
  // resultScarR: HandResultStatus = HandResultStatus.NOSETTING; // 疤痕结果右
  // resultArmHide: HandResultStatus = HandResultStatus.NOSETTING; // 手臂遮挡结果
  // resultArmHideL: HandResultStatus = HandResultStatus.NOSETTING; // 手臂遮挡结果左
  // resultArmHideR: HandResultStatus = HandResultStatus.NOSETTING; // 手臂遮挡结果右
  // resultArmComplete: HandResultStatus = HandResultStatus.NOSETTING; // 手臂完整度
  // resultArmCompleteL: HandResultStatus = HandResultStatus.NOSETTING; // 手臂完整度左
  // resultArmCompleteR: HandResultStatus = HandResultStatus.NOSETTING; // 手臂完整度右
  answerNumber = 0; // 提交次数
  resultFlexibleItem = new HandDetectionResultDetailItem();
  resultCompleteItem = new HandDetectionResultDetailItem();
  resultScarItem = new HandDetectionResultDetailItem();
  resultArmHideItem = new HandDetectionResultDetailItem();
  resultArmCompleteItem = new HandDetectionResultDetailItem();
  resultNailArtItem = new HandDetectionResultDetailItem();
}

export class BodyDetectionConfig extends Model {
  answerNumber = 0;
  coverUrl = "";
  imgUrlList: string[] = [""];
  resultStatus = 0;
  videoId = "";
  videoUrl = "";
}

export class LivenessRecognitionConfig extends Model {
  name = ""; // 姓名
  idNumber = ""; // 身份证号
  imgUrl = ""; // 图片链接
  message = ""; // 信息
  msg = ""; // 信息
  resultStatus: LrResultStatus = LrResultStatus.UNKNOWN; // 识别结果 0:未知 1:成功 2:失败(不可重试) 3:失败(可重试) 255:忽略
}

export class MultiplePersonDetectionConfig extends Model {
  successNumber = 0; // 成功样本数
  errorNumber = 0; // 异常样本数
  otherNumber = 0; // 模糊样本数
  successImgUrlList: string[] = [""]; // 成功样本
  errorImgUrlList: string[] = [""]; // 失败样本
}

export class ReplacementDetectionConfig extends Model {
  baseImgUrl = ""; // 基准照片
  successNumber = 0; // 成功样本数
  errorNumber = 0; // 异常样本数
  otherNumber = 0; // 模糊样本数
  successImgUrlList: string[] = [""]; // 成功样本
  errorImgUrlList: string[] = [""]; // 失败样本
}

export class ScreenshotDetectionConfig extends Model {
  errorNumber = 0; // 异常次数
  violationNumber = 0; // 次数限制
}

export class HairDetectionConfig extends Model {
  resultStatus = 0;
}

export class DressingDetectionConfig extends Model {
  resultStatus = 0;
}

export class SmokeDetectionConfig extends Model {
  resultStatus = 0;
}
export class CandidateConfig extends Model {
  scoreAll = 0; // 总分
  scoreAi = 0; // 得分
  aiComment = ""; // AI评价
  aiRecommendStatus = EnumAiRecommendStatus.EnumAiRecommendStatusDefault; // ai推荐状态
  aiNextSuggestion = "";
}

export class QuestionAnswerConfig extends Model {
  questionId = 0;
  key = "";
}

export class InfoItemAnswerConfig extends Model {
  infoItemId = 0;
  key = "";
}

export class ObvervationalEvaluateConfig extends Model {
  id = 0;
  name = "";
  description = "";
  match = false;
  evaluateResult = "";
  evaluateResultDesc = "";
}

export class DimensionEvaluateConfig extends Model {
  id = 0;
  name = "";
  description = "";
  evaluateResult = "";
  evaluateResultDesc = "";
  evaluateResultLevel = 0;
}

export class QuestionnaireEvaluateConfig extends Model {
  result = "";
  resultLevel = 0;
  resultDesc = "";
}

export class PsycResultConfig extends Model {
  obvervationalEvaluateList: ObvervationalEvaluateConfig[] = [
    new ObvervationalEvaluateConfig()
  ];
  dimensionEvaluateList: DimensionEvaluateConfig[] = [
    new DimensionEvaluateConfig()
  ];
  questionnaireEvaluate = new QuestionnaireEvaluateConfig();

  get obvervationalEvaluateShowList() {
    return this.obvervationalEvaluateList.filter(item => item.match);
  }
}

export class TacPsycGauge extends Model {
  questionGroupNum = 0; // AB卷时区分 题目组号 抽题时产生
  questionIds: number[] = [0];
  questionAnswerList: QuestionAnswerConfig[] = [new QuestionAnswerConfig()]; // 题目答案列表
  infoItemAnswerList: InfoItemAnswerConfig[] = [new InfoItemAnswerConfig()]; // 题目信息收集项
  psycGaugeResult = new PsycResultConfig();
  isFinish = 0; // 结束状态
  id = 0;
}

export enum ContentRelevanceTag {
  ALLLOW = 1,
  PARTIALLOW = 2,
  ALLMID = 5,
  PARTMID = 6,
  ALLHIGH = 9
}

export enum SpeechLengthTag {
  ALLSHORT = 1,
  PARTIALSHORT = 2,
  ALLLONG = 9
}

const Tags: any = {
  // 发言长度标签
  speechLengthTag: {
    1: "所有题目回答内容较短",
    2: "部分题目回答内容较短"
    // 9: "长"
  },
  // 内容相关度标签
  contentRelevanceTag: {
    1: "所有题目的内容相关度较低",
    2: "部分题目的内容相关度较低",
    5: "内容相关度：中",
    6: "内容相关度：中（部分）",
    9: "内容相关度：高"
  },
  // 表达流利度
  pronFluencyLevel: {
    name: "表达流利度",
    level: {
      0: "无法表达或未回答或完全不匹配",
      1: "候选人无法进行有效交流，只有基本问候和句子",
      2: "候选人有有限的交流能力，停顿和犹豫频繁",
      3: "候选人有基本交流能力，但表达有限",
      4: "候选人有一般交流能力，但表达稍显不流利",
      5: "候选人有较为流利的交流能力，但在复杂话题下犹豫",
      6: "候选人能流利地进行交流，但偶尔出现错误",
      7: "候选人能流利地进行复杂交流，仅有个别小错误",
      8: "候选人能非常流利地进行交流，只有个别小错误",
      9: "候选人表达非常流利，与母语者无异"
    }
  },
  // 发音准确度
  pronAccuracyLevel: {
    name: "发音准确度",
    level: {
      0: "无法表达或未回答或完全不匹配",
      1: "候选人发音不清晰几乎无法理解",
      2: "候选人发音准确度有限，可能常常被他人误解",
      3: "候选人发音勉强清晰，但仍有明显的错误",
      4: "候选人发音基本准确，但有时会出现错误",
      5: "候选人发音准确度适中，大多数人能够理解",
      6: "候选人发音准确度良好，发音清晰，只有个别小错误",
      7: "候选人发音准确度高于大多数非母语使用者，极少错误",
      8: "候选人发音非常接近母语者水平",
      9: "候选人发音与母语者无差别"
    }
  },
  // 词汇丰富度
  lexicalRichnessLevel: {
    name: "词汇丰富度",
    level: {
      0: "无法表达或未回答或完全不匹配",
      1: "候选人词汇极度匮乏，只能使用极其有限的词汇",
      2: "候选人使用词汇有限，只能进行简单的表达",
      3: "候选人能使用的词汇比较勉强，表达的内容有限",
      4: "候选人词汇丰富度比较普通，日常表达仍稍显受限",
      5: "候选人使用了相对适中词汇，能应对一般的日常对话，可能在复杂情况下受限",
      6: "候选人词汇丰富度较为良好，可能偶尔出现不准确的使用",
      7: "候选人词汇丰富度高，能够使用多种词汇和短语进行表达",
      8: "候选人词汇丰富度非常高，能轻松应对复杂场景",
      9: "候选人词汇丰富度极高，表达极具深度和广度"
    }
  },
  // 语法准确度
  grammarAccuracyLevel: {
    name: "语法准确度",
    level: {
      0: "无法表达或未回答或完全不匹配",
      1: "候选人表达内容很有限，语法错误频繁，句子理解困难",
      2: "候选人能使用简单的句型或依赖预先背诵的几句话，语法错误较多，影响句子理解",
      3: "候选人能熟练使用简单的句型，语法错误有时较多，简单句能基本理解",
      4: "候选人能使用简单与复杂的句型，复杂句型使用较少且灵活性有限，语法错误较多，复杂句型理解困难",
      5: "候选人能使用简单与复杂的句型，只有复杂句型语法错误，连接和转折得当，但通常会出错且会造成某些理解困难",
      6: "候选人能较熟练的使用一些复杂的语法结构，整体语法准确性高，只有复杂句式语法出现较少错误，但内容结构性逻辑性较差",
      7: "候选人能熟练使用复杂句子和段落进行多样表达，语法准确性只有轻微错误，但内容结构性逻辑性仍需加强，除极其偶然情况下出现的不当或简单的/非系统性错误外，大部分语句准确无误",
      8: "候选人语法多样性和准确性卓越，语法只有轻微错误，能使用各种复杂句子结构，表达内容有结构性逻辑性，除了出现英语为母语者也会犯的口误外，始终使用准确的语法结构",
      9: "候选人能非常准确和多样化的语法使用，语法完美无错误，表达结构逻辑无可挑剔，流利运用各种句式和复杂结构，有创造性表达"
    }
  }
};

// 示意图信息
export const overallInfo = [
  {
    tag: "欠佳",
    barList: [1, 2],
    color: "#EF483F"
  },
  {
    tag: "中等",
    barList: [3, 4, 5, 6],
    color: "#FF8c04"
  },
  {
    tag: "优秀",
    barList: [7, 8, 9],
    color: "#00BD82"
  }
];

export class EnglishAssessmentResultConfig extends Model {
  totalLevel = 0; // 综合等级 (0-9) 总档位0 表示候选人无有效回答 子档位-1表示无此考察项
  pronFluencyLevel = 0; // 表达流利度等级 (0-9)
  pronAccuracyLevel = 0; // 发音准确度等级 (0-9)
  lexicalRichnessLevel = 0; // 词汇丰富度等级 (0-9)
  grammarAccuracyLevel = 0; // 语法准确度等级 (0-9)
  speechLengthTag = SpeechLengthTag.ALLSHORT; // 发言长度标签 1:全部发言短 2:部分发言短 9:全部发言长
  contentRelevanceTag = ContentRelevanceTag.ALLLOW; // 内容相关度标签 1:全部差 2:部分差 5:全部中 6:部分中 9:全部高
  zScoreTotal = 0; // 最终得分
  tScoreTotal = 0; // 最终得分
  assessmentType = 0; // 测评类型

  unPronFluency() {
    return this.pronFluencyLevel > -1;
  }
  // 发音准确度
  unPronAccuracy() {
    return this.pronAccuracyLevel > -1;
  }
  // 词汇丰富度
  unLexicalRichness() {
    return this.lexicalRichnessLevel > -1;
  }
  // 语法准确度
  unGrammarAccuracy() {
    return this.grammarAccuracyLevel > -1;
  }
  // 表格
  getTable() {
    const tableList: any = [
      {
        name: "综合成绩(满级9)",
        level: this.totalLevel
      }
    ];
    // 语法准确度
    if (this.unGrammarAccuracy())
      tableList.unshift({
        name: Tags["grammarAccuracyLevel"].name,
        level: this.grammarAccuracyLevel
      });
    // 词汇丰富度
    if (this.unLexicalRichness())
      tableList.unshift({
        name: Tags["lexicalRichnessLevel"].name,
        level: this.lexicalRichnessLevel
      });
    // 发音准确度
    if (this.unPronAccuracy())
      tableList.unshift({
        name: Tags["pronAccuracyLevel"].name,
        level: this.pronAccuracyLevel
      });
    // 表达流利度
    if (this.unPronFluency())
      tableList.unshift({
        name: Tags["pronFluencyLevel"].name,
        level: this.pronFluencyLevel
      });
    return tableList;
  }

  getTags(key: string): string {
    return Tags[key][this[key]];
  }

  // 对外暴露等级文案
  getLevel() {
    const level = this.totalLevel;
    let i = 0;
    if ([1, 2].includes(level)) i = 0;
    if ([3, 4, 5, 6].includes(level)) i = 1;
    if ([7, 8, 9].includes(level)) i = 2;
    return overallInfo[i];
  }
}

export class ChineseAssessmentResultConfig extends Model {
  score = 0;
  level = 0;
  levelDesc = "";
  comment = "";
  // soeScore = 0; // 原始分数
  // prScore = 0; // 百分位

  // getEval() {
  //   const mark = this.prScore;

  //   const limit1 = 30;
  //   const limit2 = 70;

  //   if (mark === 0) {
  //     return { tag: "未作答", color: "", level: "0" };
  //   }

  //   if (mark > 0 && mark < limit1) {
  //     return { tag: "欠佳", color: "#EF483F", level: "3" };
  //   }

  //   if (mark >= limit1 && mark < limit2) {
  //     return { tag: "中等", color: "#FFC803", level: "2" };
  //   }

  //   if (mark >= limit2 && mark <= 100) {
  //     return { tag: "优秀", color: "#00BD82", level: "1" };
  //   }

  //   return { tag: "优秀", color: "#00BD82", level: "1" };
  // }
}

export enum EnumBoolOption {
  UNSET = 0,
  TRUE = 1,
  FALSE = 2
}

export class DimensionReportConfig extends Model {
  dimensionKey = ""; // 维度键
  scoreAll = 0; // 总分
  scoreAi = 0; // 得分
  scoreAiPercent = 0; // 维度AI得分、百分制、原始分
  unanswered = EnumBoolOption.FALSE;
  hasNormData = EnumBoolOption.FALSE; // 是否有常模数据
  transformScore = 0; // 维度主观题常模转换分、面试计分
  dimensionLevel = 10; // 维度评级 10,20,30,11,21,31,41
  dimensionLevelDesc = ""; // 维度评级文案
  reportDescription = "";
  dimensionWeight = 0;
  aiComment = ""; // AI评价
  dimensionName = ""; // 维度名
  dimensionDesc = ""; // 维度描述
}

export class DimensionGroupConfig extends Model {
  groupName = ""; // 维度组名
  hasNormData = EnumBoolOption.FALSE; // 是否有常模数据
  dimensionGroupNormPercent = 0; // 维度常模百分比 （近似）
  transformScore = 0; // 常模下-转换分数T分数 (近似）
  starLevel = 0; // 星级
  dimensionGroupLevel = 10; // 维度评级 10,20,30,11,21,31,41
  dimensionGroupLevelDesc = ""; // 维度评级文案
  configType = 0;
  showChart = EnumBoolOption.FALSE; // 是否显示图表
  showEvaluate = EnumBoolOption.FALSE; // 是否显示评价
  showOverview = EnumBoolOption.FALSE; // 是否显示概览结果
  readingGuidelinesType =
    EnumReadingGuidelinesType.EnumReadingGuidelinesTypeCommon; // 阅读指引维度组类型
  readingGuidelinesMessage = ""; // 阅读指引进阶能力类型结果说明
  iconUrl = ""; // 图标链接
  iconH5Url = "";
  levelDesc: string[] = [""];
  scoreLimit: number[] = [0];
  dimensionKeyList: string[] = [""];
  dimensionList: DimensionReportConfig[] = [new DimensionReportConfig()];
  aiKeyElementTextGood: string[] = [""];
  aiKeyElementTextBad: string[] = [""];
}

export class AnswerConfig extends Model {
  score = 0; // 单空得分 仅单独计算得分有含义
  words = ""; // 参考答案列表 多答案|||分隔
}

export enum EnumBlankQuestionScoreType {
  ALLRIGHT = 1,
  PERCENT = 2,
  BLANK = 3
}

export enum MessageRoleEnum {
  AI = "ai",
  CANDIDATE = "candidate"
}

export class AsrTextConfig extends Model {
  bg = 0;
  ed = 0;
  txt = "";
  highLight = false;
}

export class MessageConfig {
  content = "";
  role = MessageRoleEnum.AI;
  channelName = "";
  videoId = ""; // 视频id
  asrText = ""; // asr结果
  asrTextList: AsrTextConfig[] = [new AsrTextConfig()]; // asr结果
  audioUrl = ""; // 音频链接
  imageUrlList: string[] = [""]; // 截图链接列表
  videoUrl = ""; // 视频链接
}

export class AnswerItemConfig {
  contextList: string[] = [""]; // 填空题答案
  keyList: string[] = [""]; // 选择题答案
  messages: MessageConfig[] = [new MessageConfig()]; // 视频题答案
  hasAnswer = false;
}

export class BlankQuestionConfig extends Model {
  answerList: AnswerConfig[] = [new AnswerConfig()]; // 参考答案
  scoreType = EnumBlankQuestionScoreType.ALLRIGHT; // 判分类型 1:全对全分 2:比例分 3:空单独计算
  ignoreBlank = EnumBoolOption.FALSE; // 是否忽略答案的空白
  strictOrder = EnumBoolOption.FALSE; // 是否顺序严格
}

export class ResultConfig extends Model {
  scoreAll = 0; // 总分
  scoreAi = 0; // 得分
  aiComment = ""; // AI评价
  blankIsRight = [false]; // 填空题是否正确
}

export class DimensionConfig extends Model {
  dimensionKey = ""; // 维度键
  dimensionName = ""; // 维度名
  scoreAll = 0; // 总分
  scoreAi = 0; // 得分
  scoreAiPercent = 0;
}

export class OptionConfig extends Model {
  optionKey = "";
  content = "";
  contentTextOnly = "";
  defaultScorePercent = 0;
}

export class QuestionConfig extends Model {
  questionId = ""; // 题目id
  questionType = EnumQuestionType.EnumQuestionTypeBlanks; // 题目类型
  desc = "";
  descTextOnly = ""; // 题干
  appendDesc = "";
  audioDescUrl = "";
  referenceAnswer = "";
  referenceAnswerTextOnly = "";
  optionList: OptionConfig[] = [new OptionConfig()]; // 选项列表
  blankQuestionConfig = new BlankQuestionConfig();
  answer = new AnswerItemConfig();
  result = new ResultConfig();
  dimensionList: DimensionConfig[] = [new DimensionConfig()];
}

export enum EnumErrorInfoTask {
  BG_CHECK_FINANCIAL = "bgCheckFinancial",
  BG_CHECK_IDENTITY = "bgCheckIdentity",
  COLOR = "colorDetection",
  FACE = "faceDetection",
  FACE_SHOW = "faceShowDetection",
  HAND = "handDetection",
  JUMP_OUT = "jumpOutDetection",
  LIVENESS = "livenessRecognition",
  MULTIPLE_PERSON = "multiplePersonDetection",
  REPLACEMENT_PERSON = "replacementPerson",
  SCREENSHOT = "screenshotDetection"
}

export class ErrorInfoConfig extends Model {
  task = EnumErrorInfoTask.COLOR; // 异常项类型
  result = EnumBoolOption.UNSET; // 异常结果 0:未检测 1:有异常 2:无异常
  resMessage = ""; // 有异常特殊文案
}

export class ReportMessageConfig extends Model {
  message = ""; // 报告评价内容
  messageType = 0; // 报告评价类型 1:优点 2:缺点 3:建议 4: 中性
}

export class FaceAssessment extends Model {
  score = 0;
  message = "";
}

export class ReportConfig extends Model {
  colorDetection = new ColorDetectionConfig();
  faceDetection = new FaceDetectionConfig();
  faceShowDetection = new FaceShowDetectionConfig();
  faceAssessment = new FaceAssessment();
  signature = new SignatureConfig();
  handDetection = new HandDetectionConfig();
  bodyDetection = new BodyDetectionConfig();
  hairDetection = new HairDetectionConfig();
  dressingDetection = new DressingDetectionConfig();
  smokeDetection = new SmokeDetectionConfig();
  jumpOutDetection = new JumpOutDetectionConfig();
  livenessRecognition = new LivenessRecognitionConfig();
  multiplePersonDetection = new MultiplePersonDetectionConfig();
  replacementDetection = new ReplacementDetectionConfig();
  screenshotDetection = new ScreenshotDetectionConfig();
  candidate = new CandidateConfig();
  tacPsycGaugeList: TacPsycGauge[] = [new TacPsycGauge()];
  englishAssessmentResult = new EnglishAssessmentResultConfig();
  chineseAssessmentResult = new ChineseAssessmentResultConfig();
  dimensionReportList: DimensionReportConfig[] = [new DimensionReportConfig()];
  dimensionGroupList: DimensionGroupConfig[] = [new DimensionGroupConfig()];
  questionList: QuestionConfig[] = [new QuestionConfig()];
  errorInfoList: ErrorInfoConfig[] = [new ErrorInfoConfig()];
  reportMessageList: ReportMessageConfig[] = [new ReportMessageConfig()]; // 报告评价结果列表
  readingDetection = { resultStatus: 0 }; // 0 未检测 1 通过 2 高风险 3 中风险
}

export class CompanyInfoConfig extends Model {
  companyId = 0; // 公司id
  name = ""; // 公司名
  shortname = ""; // 公司简称
  logoUrl = ""; // 公司LOGO
  companyIcon = ""; // 公司icon
  industryId = 0; // 行业id
}

export class ExamInfoConfig extends Model {
  name = ""; // 名称
  remark = ""; // 备注
  positionId = 0; // 岗位id
  positionName = ""; // 岗位名称
}

export class MetaInfoConfig extends Model {
  candidateId = ""; // 候选人id
  connectCode = ""; // 候选人链接码
  examId = 0; // 面试id
  examVersionId = 0; // 面试版本id
  companyId = 0; // 公司id
}

export class SignInfo {
  name = ""; // 登记信息名
  value = ""; // 内容
}

export class BaseInfoConfig extends Model {
  loginId = ""; // 登录键
  showName = ""; // 姓名
  phone = ""; // 电话
  email = ""; // 邮箱
  idNumber = ""; // 身份证号
  photoUrl = ""; // 头像地址
  remark = ""; // 备注
  tags: string[] = [""]; // 标签
  params: SignInfo[] = [new SignInfo()];
}

export enum EnumAutoSubmitType {
  EnumAutoSubmitNormal = 0,
  EnumAutoSubmitTypeTime = 1,
  EnumAutoSubmitTypeScreen = 2,
  EnumAutoSubmitTypeJump = 3,
  EnumAutoSubmitTypeLr1 = 4,
  EnumAutoSubmitTypeLr2 = 5,
  EnumAutoSubmitTypeExpire = 6,
  EnumAutoSubmitTypeRepeatCreate1 = 7,
  EnumAutoSubmitTypeRepeatCreate2 = 8,
  EnumAutoSubmitTypeOpenapi1 = 9,
  EnumAutoSubmitTypeOpenapi2 = 10,
  EnumAutoSubmitTypeNameIdCheck = 14
}

export class TimeInfoConfig extends Model {
  createdTime = ""; // 创建时间
  loginTime = ""; // 签到时间
  beginTime = ""; // 开始答题时间
  submitTime = ""; // 交卷时间
  isAutoSubmit = EnumBoolOption.TRUE; // 是否自动交卷
  autoSubmitType = EnumAutoSubmitType.EnumAutoSubmitTypeExpire; // 自动交卷类型
}

export class AuditInfoConfig extends Model {
  score = 0; // 最终分数
  auditStatus = EnumAuditStatus.EnumAuditStatusNoAudit; // 评估结果
  auditMember = ""; // 评估人
  auditDesc = ""; // 评估评价
  auditTime = ""; // 评估时间
}

export class CandidateInfoConfig extends Model {
  metaInfo = new MetaInfoConfig();
  baseInfo = new BaseInfoConfig();
  timeInfo = new TimeInfoConfig();
  auditInfo = new AuditInfoConfig();
}

export class ReportShowConfigV5 extends Model {
  name = ""; // 模块名
  showName = ""; // temp
  versionId = 0; // 选择的版本id
  isHidden = true; // 当前模块是否隐藏
  sort = 0; // 自定义排序键
  optionMap = {}; // 自定义配置项结果
}

export class ShareConfig extends Model {
  tid = ""; // 校验参数
  sid = ""; // 加解密参数
  needEncode = true; // 是否需要加密
  isEncode = true; // 是否解密版
}

interface CandidateNewResultReq {
  connectCode: string;
  tid: string;
  sid?: string;
}

export class CandidateNewResult extends Model {
  companyInfo = new CompanyInfoConfig();
  examInfo = new ExamInfoConfig();
  candidateInfo = new CandidateInfoConfig();
  report = new ReportConfig();
  reportShowConfigV5: ReportShowConfigV5[] = [new ReportShowConfigV5()];
  reportShowConfigV6: ReportShowConfigV5[] = [new ReportShowConfigV5()];
  shareConfig = new ShareConfig();

  static get(params: CandidateNewResultReq) {
    return request
      .postInterviewApi("/public/audit/questionAnswers", params)
      .then(resp => {
        const t = new CandidateNewResult(resp).assign(resp.data.data);
        return t;
      });
  }

  static async getTid(candidateId: number) {
    const result = await request.postInterviewApi("/hr/candidate/sid", {
      candidateId
    });
    return {
      tid: result.data.data.tid,
      sid: result.data.data.sid
    };
  }
}
